export enum TransactionType {
  NEW = "NEW",
  REN = "REN",
  EXP = "EXP",
  MTA = "MTA",
  CANX = "CANX"
}
